import styled from 'styled-components';

const HomeContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  
  @media(max-width: 500px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const Title = styled.h1`
  max-width: 30vw;
    
  @media(max-width: 500px) {
    max-width: 100vw;
  }
  
  @media(min-width: 1090px) {
    max-width: 20vw;
    width: 20vw;
  }
`;

const Image = styled.img`
  position: absolute;
  right: 0;
  margin: 0;
  max-width: 50vw;
  width: 50vw;
  height: auto;
  mask-image: url(${(props) => props.mask});
  webkit-mask-image: url(${(props) => props.mask});
  mask-mode: alpha;
  webkit-mask-mode: alpha;
  mask-repeat: no-repeat;
  webkit-mask-repeat: no-repeat;
  mask-position: center;
  webkit-mask-position: center;
    
  @media(max-width: 500px) {
    position: relative;
    bottom: 0;
    max-width: 90vw;
    width: 90vw;
  }
  @media(min-width: 1090px) {
    max-width: 30vw;
    width: 30vw;
  }
`;

const CtoRow = styled.div`
  display: flex;
  flex-direction: row;
  z-index: 4;
  justify-items: center;
  * {
    margin-right: 8px;
  }
`;

export {
    HomeContainer,
    Title,
    Image,
    CtoRow
}
